import {usePermission} from '../../../../hooks/usePermission'
import {Permission} from '../../../../types'

import usePipelineParentProjectId from './usePipelineParentProjectId'

function usePermissionCanEditPipeline() {
  const parentProjectId = usePipelineParentProjectId()
  const canEditPipeline = usePermission(Permission.EDIT_PROJECT, parentProjectId)
  const canViewPipelineSettings = usePermission(
    Permission.VIEW_BUILD_CONFIGURATION_SETTINGS,
    parentProjectId,
  )
  return {canEditPipeline, canViewPipelineSettings, parentProjectId}
}

export default usePermissionCanEditPipeline
